import { Component, OnInit, Input, HostListener, OnDestroy } from '@angular/core';
import { Transaction } from 'src/app/models/transaction';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { AuthService } from '../../services/auth.service';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { createMerchantReturnUrl, sleep } from 'src/app/shared/helps/helps';
import { FLAGS_NAME } from 'src/app/core/constants/General-constants';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
    @Input() footer: boolean;
    @Input() itsMobileCtrl: boolean;
    @Input() isVoucher: boolean = false;
    @Input() startLoading: boolean = false;
    disPlayEnable: boolean;
    user: Transaction;
    urlReturnMerchant: string;
    token: string;
    loading: boolean = false;
    hintText: string = '';

    orderIdSubscribe: any;

    private parameter = 'RemoveFooterLogos';
    private flag = 'RemoveFooterLogosFf';
    private platform = 'payvalida';
    RemoveFooterLogosFf: boolean = false;
    enableShopifyThankYouPageFf: boolean = false;
    wait3SecsForOrderNotificationsFf: boolean = false;
    wait7SecsForOrderNotificationsFf: boolean = false;
    wait15SecsForOrderNotificationsFf: boolean = false;

    constructor(private readonly tokenServiceService: TokenServiceService, private readonly authService: AuthService, private featureFlagService: PayvalidaFeatureFlagService) { }

    ngOnInit() {
        this.user = this.tokenServiceService.getAndDecodeToken();
        this.token = this.tokenServiceService.getToken();
        this.urlReturnMerchant = ''

        this.featureFlagService.getFeatureFlagValue(this.parameter, this.flag, this.platform).toPromise().then(async (response: boolean) => {
            this.RemoveFooterLogosFf = response;
        });

        this.featureFlagService.getFeatureFlagValue(this.user.MERCHANT_ID, FLAGS_NAME.ENABLE_SHOPIFY_THANK_YOU_PAGE_FF, this.platform).toPromise().then(async (response: boolean) => {
            this.enableShopifyThankYouPageFf = response;
        });

        this.getUrlReturnMerchant();
    }

    ngOnDestroy() {
        this.orderIdSubscribe?.unsubscribe();
    }

    async getUrlReturnMerchant() {
        this.enableShopifyThankYouPageFf = await this.featureFlagService.getFeatureFlagValue(this.user.MERCHANT_ID, FLAGS_NAME.ENABLE_SHOPIFY_THANK_YOU_PAGE_FF, this.platform).toPromise()

        this.setMobile(window.innerWidth);
        this.orderIdSubscribe = this.authService.orderID$.subscribe(async (orderID) => {
            let returnUrl = createMerchantReturnUrl(orderID, this.user.MERCHANT_URL_RETURN);

            let shouldUpdateForShopify = returnUrl && returnUrl.includes('/processing') && this.enableShopifyThankYouPageFf && this.isVoucher;

            if (shouldUpdateForShopify) {
                while (!this.startLoading) await sleep(1 * 1000);

                this.loading = true;

                this.wait3SecsForOrderNotificationsFf = await this.featureFlagService.getFeatureFlagValue(this.user.MERCHANT_ID, FLAGS_NAME.WAIT_3_SECS_FOR_NOTIFICATIONS, this.platform).toPromise();

                if (!this.wait3SecsForOrderNotificationsFf) this.wait7SecsForOrderNotificationsFf = await this.featureFlagService.getFeatureFlagValue(this.user.MERCHANT_ID, FLAGS_NAME.WAIT_7_SECS_FOR_NOTIFICATIONS, this.platform).toPromise();

                if (!this.wait7SecsForOrderNotificationsFf) this.wait15SecsForOrderNotificationsFf = await this.featureFlagService.getFeatureFlagValue(this.user.MERCHANT_ID, FLAGS_NAME.WAIT_15_SECS_FOR_NOTIFICATIONS, this.platform).toPromise();

                switch (true) {
                    case this.wait3SecsForOrderNotificationsFf:
                        await sleep(3 * 1000);
                        break;
                    case this.wait7SecsForOrderNotificationsFf:
                        await sleep(7 * 1000);
                        break;
                    case this.wait15SecsForOrderNotificationsFf:
                        await sleep(15 * 1000);
                        break;
                    default:
                        await sleep(1.5 * 1000);
                        break;
                }

                const newUrl = new URL(returnUrl);
                const params = new URLSearchParams(newUrl.search);
                params.delete('order');
                params.append('completed', 'true');

                returnUrl = `${newUrl.origin}${newUrl.pathname}?${params.toString()}`;
            }

            if (returnUrl) this.urlReturnMerchant = returnUrl;
            this.loading = false;
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        const width: number = event.target.innerWidth;
        this.setMobile(width);
    }

    setMobile(width: number) {
        if (this.itsMobileCtrl) {
            this.disPlayEnable = width < 768;
        } else {
            this.disPlayEnable = true;
        }
    }
}
